import { i18n } from 'i18n';

export enum EPaymentModel { // TODO: get enum from api
	CPA = 'cpa',
	CPP = 'cpp',
}

export const EPaymentModelMap = {
	[EPaymentModel.CPA]: {
		color: 'green',
		text: i18n.t('CPA'),
		fullName: i18n.t('Cost Per Action (оплата за действие)'),
		description: i18n.t('Платим, когда подписчики выполнят действие (например, регистрация)'),
	},
	[EPaymentModel.CPP]: {
		color: 'magenta',
		text: i18n.t('CPP'),
		fullName: i18n.t('Cost Per Click (Оплата за клик)'),
		description: i18n.t('Платим, когда подписчики кликают по вашей ссылке'),
	},
};
